export const USER_STATUS_ACTIVE = 'active';
export const USER_STATUS_PENDING = 'pending';
export const USER_STATUS_DISABLED = 'disabled';
